import React from 'react';
import './Projects.css';

const Projects = () => {
  const featuredProjects = [
    {
      title: 'Interactive GIS Coverage Map',
      subtitle: 'RTV Slovenia',
      description: 'A GIS-supported application for visualizing DVB-T, DAB+ and FM signal coverage across Slovenia, built during my time as a student developer on the Transmitters and Communications Development team. Coverage data is processed in Python using the ArcPy API — raster datasets are transformed from the Gauss–Krüger coordinate system to Web Mercator (EPSG:3857) and converted into optimized binary raster files. These datasets, generated by a custom C++ engine, are served through backend spatial raster queries and rendered on an interactive map. Users can search their address to check DVB-T, DAB+ and FM signal availability, evaluate signal quality, and see the direction of the transmitter.',
      technologies: ['Svelte', 'Python', 'ArcPy', 'Leaflet', 'GIS'],
      link: 'https://www.rtvslo.si/oz/oddajanje',
      tag: 'Internship Project'
    },
    {
      title: 'Hello Kitty Game',
      subtitle: '',
      description: 'A cute, side-scrolling platformer inspired by Super Mario, where Hello Kitty runs and jumps through colorful levels, collects items, and avoids enemies along the way.',
      technologies: ['JavaScript'],
      link: 'https://super-kitty-game.onrender.com/',
      tag: 'Personal Project'
    }
  ];

  // eslint-disable-next-line no-unused-vars
  const otherProjects = [
    {
      title: 'Chat App',
      description: 'Full-stack chat application with authentication and real-time messaging.',
      technologies: ['React', 'Node.js'],
      link: 'https://chat-app-i0io.onrender.com/login'
    },
    {
      title: 'AI Fitness Trainer',
      description: 'An AI-powered fitness assistant that helps users achieve their health and fitness goals through personalized workouts, diet plans, and intelligent conversation.',
      technologies: ['TypeScript', 'Next.js'],
      link: 'https://ai-fitness-trainer-oks7.onrender.com/'
    }
  ]; 

  return (
    <section className="projects" id="projects">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">PROJECTS</h2>
        </div>

        <div className="featured-projects">
          {featuredProjects.map((project, index) => (
            <div key={index} className="featured-project-card">
              <div className="featured-project-content">
                <span className="featured-tag">{project.tag}</span>
                <h3 className="featured-project-title">{project.title}</h3>
                <p className="featured-project-subtitle">{project.subtitle}</p>
                <p className="featured-project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                  <span>View Project</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/*
        <div className="other-projects-header">
          <h3>More Projects</h3>
        </div>

        <div className="projects-grid">
          {otherProjects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-number">0{index + 1}</div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
              <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                <span>View Project</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
            </div>
          ))}
        </div>
        */}
      </div>
    </section>
  );
};

export default Projects;